import React from 'react';
import { TruckIcon } from 'lucide-react';
import { IMAGES } from '../data/site';
import { CATALOG, lowestPrice } from '../data/catalog';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { formatMXN } from '../utils/currency';
import { WhatsAppButton } from './WhatsAppButton';
import { PerksStrip } from './PerksStrip';
export function Hero() {
  return <section className="bg-navy-900 text-white" data-id="element-65" data-mp="4jvwndf77cxb">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 pb-8 pt-7 sm:px-6 sm:pb-14 sm:pt-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-12" data-id="element-66" data-mp="128frrovbsnyc">
        <div data-id="element-67" data-mp="sai535t46z7u">
          <p className="mb-3 flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.16em] text-accent-500" data-id="element-68" data-mp="sa9nj0m1r5qb">
            <span className="guide-line h-px w-6" aria-hidden="true" data-id="element-69" data-mp="nbyh6zuyndcu" />
            Bovedilla · Casetón · Vigueta
          </p>

          <h1 className="text-balance font-display text-[1.95rem] font-bold leading-[1.04] sm:text-5xl lg:text-[3.4rem]" data-id="element-70" data-mp="382ff5o82r4ex">
            Tu losa sin laberintos: bovedilla EPS desde <span className="text-accent-500" data-id="element-71" data-mp="3j928hxbf86zr">$300</span> y entrega sin
            costo
          </h1>

          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-steel-200 sm:mt-5 sm:text-lg" data-id="element-72" data-mp="3o6u6n92nspce">
            Deja de perder días entre proveedores, medidas y fletes. Arma tu pedido, ve tu precio al instante y
            recíbelo en tu obra en el Bajío.
          </p>

          <div className="mt-5 flex flex-col gap-2.5 sm:mt-7 sm:flex-row" data-id="element-73" data-mp="30gztsricb0s5">
            <a href="#cotizador" className="inline-flex items-center justify-center rounded-md bg-accent-500 px-7 py-4 text-base font-semibold text-white shadow-lg shadow-black/30 transition-[background-color,transform] duration-150 ease-out hover:bg-accent-600 active:scale-[0.98] sm:text-lg" data-id="element-74" data-mp="3599ki9ra44vh">
              Armar mi pedido y ver precio
            </a>
            <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="hero" variant="white" size="lg" data-id="element-75" data-mp="2lla70r5byjmd" />
          </div>
          <p className="mt-2.5 text-xs text-steel-400 sm:text-sm" data-id="element-76" data-mp="najgjljwi9dy">Respuesta rápida. Precios netos lista 2026.</p>

          <dl className="mt-6 grid grid-cols-3 gap-px overflow-hidden rounded-lg bg-white/10" data-id="element-77" data-mp="icrsj2mdn7f1">
            {CATALOG.map(cat => <div key={cat.id} className="bg-navy-800 px-2.5 py-2.5 sm:px-4 sm:py-3" data-id="element-78" data-mp="1b0vvvhhh78ek">
                <dt className="text-xs text-steel-400 sm:text-sm" data-id="element-79" data-mp="1ayjilhmnxm7u">{cat.shortLabel} desde</dt>
                <dd className="font-display text-2xl font-semibold leading-tight text-white" data-id="element-80" data-mp="15zq0fbwfl71c">
                  {formatMXN(lowestPrice(cat))}
                </dd>
              </div>)}
          </dl>
        </div>

        <figure className="relative" data-id="element-81" data-mp="3lsp1x9cpsbcb">
          <img src={IMAGES.hero} alt="Colaborador de OA LOSAS sonriendo frente a bovedilla EPS en existencia" className="aspect-[16/10] w-full rounded-xl object-cover object-[50%_32%] shadow-2xl shadow-black/40 sm:aspect-[16/9] lg:aspect-[4/5] lg:object-center" loading="eager" fetchPriority="high" data-id="element-82" data-mp="3ltqdrg1k11v3" />
          <figcaption className="absolute bottom-3 left-3 right-3 flex items-center gap-2.5 rounded-lg bg-white/95 px-3 py-2.5 text-navy-900 shadow-lg sm:bottom-4 sm:left-4 sm:right-auto sm:px-4" data-id="element-83" data-mp="269hegalb7f5x">
            <TruckIcon className="h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-84" data-mp="2g0bzjbmtk8ps" />
            <span className="text-sm leading-tight" data-id="element-85" data-mp="2kyn9dmd46j80">
              <strong className="block font-semibold" data-id="element-86" data-mp="2kxc75qzbhjj0">Entrega sin costo</strong>
              en pedidos desde $5,000
            </span>
          </figcaption>
        </figure>
      </div>

      <div className="mx-auto max-w-content px-4 pb-6 sm:px-6 sm:pb-12" data-id="element-87" data-mp="2tyaeoj8ys96c">
        <PerksStrip data-id="element-88" data-mp="umzky379aib1" />
      </div>
    </section>;
}